
declare const $;
export function collapsed_directive() {
    "ngInject";

    var directive = {
        link: link,
        restrict: 'A',
        scope: {
            collapsed: '='
        }

    };
    return directive;

    function link(scope, element, attrs) {
        
        var css = {
            height: ''
        };
        var cssTo = { height: '0' };
        if (!scope.collapsed) {
            element.addClass('in')
                .addClass('collapse')
                .attr('aria-expanded', true)
                .attr('aria-hidden', false)
                .css(css);
        }

        scope.$watch("collapsed", (shouldCollapse) => {
            if (shouldCollapse) {
                collapse(element)
            } else {
                expend(element)
            }
        });
    }
}

function collapse(element) {
    $(element).slideDown()
}
function expend(element) {
    $(element).slideUp()
}
function ControllerController() {

}



// WEBPACK FOOTER //
// ./src/directives/collapsed/collapsed.ts